import React, { useCallback, useRef } from 'react';

import { join, map, split } from 'lodash';

import styles from './OtpInput.module.scss';

interface Props {
  onSubmit?: (otp: string) => void;
  otp: string;
  setOtp: React.Dispatch<React.SetStateAction<string>>;
}

const OtpInput = (prop: Props) => {
  const { onSubmit, setOtp, otp } = prop;
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const focusNextInput = (index: number) => {
    if (index < 5) {
      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  const focusPrevInput = (index: number) => {
    if (index > 0) {
      const prevInput = inputRefs.current[index - 1];
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const handleChange = useCallback(
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value) {
        focusNextInput(index);
      }

      setOtp((prevOtp: string) => {
        const otpArr = split(prevOtp, '');
        otpArr[index] = value;

        if (index === 5) {
          onSubmit && onSubmit(join(otpArr, ''));
        }

        return join(otpArr, '');
      });
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [otp],
  );

  const handleKeyUp = useCallback(
    (index: number) => (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Backspace' && (e.target as HTMLInputElement).value === '') {
        focusPrevInput(index);
      }
    },
    [],
  );

  return (
    <div className={styles.OtpInput}>
      {map(Array(6), (data, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          className={styles.otpInput}
          name={`otp${index}`}
          onChange={handleChange(index)}
          onKeyUp={handleKeyUp(index)}
          ref={(el) => (inputRefs.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default OtpInput;
